/* Company Confidential, Copyright (c) 2017 CRF Box, Ltd. All Rights Reserved. */

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  openSponsorModal,
  updateSponsorSelection,
  openHelpdeskModal,
  logOutAndCleanSession,
  showMigrationModal
} from '../../../actions/actions';
import { MODAL_TYPE_SPONSORS, MODAL_TYPE_HELPDESK } from '../../../constants/modalTypes';
import { CHANGE_SPONSOR_MODAL_TITLE, HELPDESK_MODAL_TITLE } from '../../../const';
import ModularHeader from './modularheader.component';

export const mapStateToProps = (state, ownProps) => {
  return {
    error: state.login.error,
    user: state.login.user,
    selectedSponsor: state.sponsor.selectedSponsor,
    logoutUrl: state.login.clientConfiguration.SSOLogoutUrl,
    fetchingUserDetails: state.sponsor.fetchingUserDetails,
    isFetching: state.sponsor.isFetching,
    idPortalUrl: state.login.clientConfiguration.idPortalUrl,
    idPortalApiUrl: state.login.clientConfiguration.idPortalApiUrl,
    clientApp: state.login.clientConfiguration.idPortalClientId,
    idPortalMigration: state.idPortalMigration.idPortalStatus,
    accessToken: state.login.clientConfiguration.accessToken
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    signOut: (SSOLogoutUrl) => {
      dispatch(logOutAndCleanSession(SSOLogoutUrl));
    },
    changeSponsor: (selectedSponsor) => {
      dispatch(updateSponsorSelection(selectedSponsor));
      dispatch(
        openSponsorModal(MODAL_TYPE_SPONSORS, {
          className: 'tc-modal tc-modal-lg',
          title: CHANGE_SPONSOR_MODAL_TITLE,
          shouldCloseOnOverlayClick: false
        })
      );
    },
    openHelpdesk: () => {
      dispatch(
        openHelpdeskModal(MODAL_TYPE_HELPDESK, {
          className: 'helpdesk-dialog tc-modal tc-modal-sm',
          title: HELPDESK_MODAL_TITLE,
          shouldCloseOnOverlayClick: false
        })
      );
    },
    showMigrationModal() {
      dispatch(showMigrationModal());
    }
  };
};

const CHeader = withRouter(connect(mapStateToProps, mapDispatchToProps)(ModularHeader));

export default CHeader;
